export default __webpack_public_path__ + "static/media/back-arrow-white.87543b61.svg";